export default "__VITE_ASSET___eIsKgub__"